import React from 'react';
import { hasPermission, hasAnyPermission } from '../../utils/permissions';

// 權限控制元件 - 有權限才顯示子元件
const PermissionGuard = ({ user, permission, permissions, requireAll = false, fallback = null, children }) => {
  let hasAccess = false;

  if (permission) {
    // 單一權限檢查
    hasAccess = hasPermission(user?.role, permission);
  } else if (permissions && Array.isArray(permissions)) {
    // 多權限檢查
    if (requireAll) {
      hasAccess = permissions.every(p => hasPermission(user?.role, p));
    } else {
      hasAccess = hasAnyPermission(user?.role, permissions);
    }
  }

  if (!hasAccess) {
    return fallback;
  }

  return <>{children}</>;
};

export default PermissionGuard;
